// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"SectionTextArticle_ctaWrapper__eQcNk","imageWrapper":"SectionTextArticle_imageWrapper__1HOb3","textWrapper":"SectionTextArticle_textWrapper__73Jup"};